module.exports = __webpack_public_path__ + "static/media/p3-box.14b3f21b.csv";